export const types = {
    NEW: 'NEW-FOLDER',
    DELETE: 'DELETE',
    COPY: 'COPY',
    MOVE: 'MOVE'
};